import { ref } from 'vue'

// Table view preferences. Module scope keeps them for the page's lifetime, so
// they survive navigating into an alert and back. Reset on reload.
export const itemsPerPage = ref(10)
export const sortBy = ref([{ key: 'sent', order: 'desc' }])
